import { Flex, Image } from "@chakra-ui/react";
import React from "react";

const REIVHeader: React.FC = () => {
  return (
    <Flex justifyContent="center" p={4}>
      <Image w={"270px"} maxW="80vw" src="reiv-logo.svg" alt="REIV Logo" />
    </Flex>
  );
};

export default REIVHeader;
